export const STAGE_STATUSES = ["Pending", "In Progress", "Completed"];

export const STAGE_EDIT_ROLES = ["dev", "admin", "srdev", "senior admin"];

export const canEditWorkflowStages = (userRole) =>
  STAGE_EDIT_ROLES.includes(userRole);

export const getWorkflowProgress = (stages = []) => {
  const total = stages.length;
  const completed = stages.filter((stage) => stage.status === "Completed").length;
  const inProgress = stages.filter((stage) => stage.status === "In Progress").length;
  const pending = stages.filter((stage) => stage.status === "Pending").length;

  return {
    total,
    completed,
    inProgress,
    pending,
    percent: total ? Math.round((completed / total) * 100) : 0,
  };
};

export const getStageStatusClass = (status) => {
  if (status === "Completed") return "stage-completed";
  if (status === "In Progress") return "stage-in-progress";
  return "stage-pending";
};
